var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.agreed)?_c('div',{ref:"cookie",class:[`${_vm.$appPrefix}-cookie`, ..._vm.classes]},[_c('div',{staticClass:"cookie-content"},[_c('Container',[_c('CookieSettings',{attrs:{"language":_vm.language},on:{"agreed":_vm.onAgreed,"openPolicy":_vm.handleFooterClick}})],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }